import Service from '@/services/Service'

class CityService extends Service {
  constructor() {
    super('CITY')
    this.resource = 'cities'
  }

  translateToFirebird(obj) {
    let objFirebird = {
      CODIGO: obj.codigo,
      DESCRICAO: obj.descricao,
      UF: obj.uf,
      CODIGOMUNICIPIO: obj.codigoMunicipio,
    }

    return objFirebird
  }

  translateFromFirebird(obj) {
    let objeto = {
      codigo: obj.CODIGO,
      descricao: obj.DESCRICAO,
      uf: obj.UF,
      codigoMunicipio: obj.CODIGOMUNICIPIO,
    }

    return objeto
  }

  async getCity(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    let data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }

  async getCities(query = null) {
    if (query) {
      let requestUrl = `${this.resource}?`
      
      query = this.encodeQueryValues(query);

      if (query.codigo && query.codigo.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CODIGO=${query.codigo}`
          : `CODIGO=${query.codigo}`
      } else if (query.descricao && query.descricao.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&DESCRICAO=${query.descricao}`
          : `DESCRICAO=${query.descricao}`
      } else if (query.uf && query.uf.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&UF=${query.uf}`
          : `UF=${query.uf}`
      } else if (query.codigoMunicipio && query.codigoMunicipio.length > 0) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CODIGOMUNICIPIO=${query.codigoMunicipio}`
          : `CODIGOMUNICIPIO=${query.codigoMunicipio}`
      } else if (query.hibrido && query.hibrido.length > 0) {
        // consulta pelo codigo ou nome 
        requestUrl += this.hasParameter(requestUrl)
          ? `&HIBRIDO=${query.hibrido}`
          : `HIBRIDO=${query.hibrido}`
      }

      if (query.todos)
        requestUrl += this.hasParameter(requestUrl)
          ? `&TODOS=${query.todos}`
          : `TODOS=${query.todos}`
      else
        requestUrl += this.hasParameter(requestUrl)
          ? `&page=${query.page}`
          : `page=${query.page}`

      return await this.getAPI(requestUrl)
    } else {
      return Promise.reject('Ocorreu um erro')
    }
  }
}

export default new CityService()
